<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Payment GateWay</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Payment GateWay</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="PaymentGateWay">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'PaymentGateWayList'}"><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label">Gateway Name</label>
                    <input type="text" id="gateway_name" name="gateway_name"
                           v-bind:class="{'has-error' : errors.has('gateway_name')}"
                           v-validate="'required'"
                           v-model="value.gateway_name" class="form-control gateway_name"
                           placeholder="Gateway Name" disabled>
                    <div class="help text-danger" v-show="errors.has('gateway_name')">
                      {{ errors.first("gateway_name") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Display Name</label>
                    <input type="text" id="display_name" name="display_name"
                           v-bind:class="{'has-error' : errors.has('display_name')}"
                           v-validate="'required'"
                           v-model="value.display_name" class="form-control display_name"
                           placeholder="Display Name">
                    <div class="help text-danger" v-show="errors.has('display_name')">
                      {{ errors.first("display_name") }}
                    </div>
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Discount Type</label>
                    <div class="form-group">
                      <el-select v-model="value.discount_type" name="discount_type"
                                 style="width: 100%" placeholder="select status">
                        <el-option
                          v-for="item in [{value: 'percentage', label: 'Percentage'}, {value: 'flat', label: 'Flat'}]"
                          :key="item.value" v-bind:class="{'has-error' : errors.has('is_published')}"
                          :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                      <div class="help text-danger" v-show="errors.has('discount_type')">
                        {{ errors.first("discount_type") }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Discount Rate</label>
                    <input type="text" id="discount_rate" name="discount_rate"
                           v-bind:class="{'has-error' : errors.has('discount_rate')}"
                           v-validate="'required'"
                           v-model="value.discount_rate" class="form-control discount_rate"
                           placeholder="Discount Rate">
                    <div class="help text-danger" v-show="errors.has('discount_rate')">
                      {{ errors.first("discount_rate") }}
                    </div>
                  </div>
                  <div class="form-group" v-if="value.gateway_name === 'PayTm'">
                    <label class="control-label">GST Percentage</label>
                    <input type="text" id="gst_percentage" name="gst_percentage"
                           v-model="value.gst_percentage" class="form-control gst_percentage"
                           placeholder="GST Percentage">
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Is Active</label>
                    <div class="form-group">
                      <el-select v-model="value.is_active" v-validate="'required'" name="is_active"
                                 style="width: 100%" placeholder="select status">
                        <el-option
                          v-for="item in [{value: 'inactive', label: 'Inactive'}, {value: 'active', label: 'Active'}]"
                          :key="item.value" v-bind:class="{'has-error' : errors.has('is_published')}"
                          :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                      <div class="help text-danger" v-show="errors.has('is_active')">
                        {{ errors.first("is_active") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "PaymentGateWayForm",
  metaInfo: {
    title: "Payment GateWay | Dotlines"
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {}
  }),
  methods: {


    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/payment_gateways";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/payment_gateways/" + _this.$route.params.id
            method = "PUT";
          }


          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "PaymentGateWayList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/payment_gateways/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });


      }

      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>

